import React from 'react';

// external libs

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// utilities

import { configs } from '../../../../constants/configs/configs';
import { languageTypes } from '../../../../constants/common/languageTypes';
import type { LANGUAGE_TYPE } from '../../../../constants/common/languageTypes';

// components

import LanguageSwitch, { LanguageProps } from './LanguageSwitch';

// ActionCreators

import { changeLang } from '../../../../actions/common/actionCreators';

export interface LanguageSwitchProps {
  actions?: {
    changeLang
  },
  details: {
    name: string,
    // className: string,
    text: string
  },
  index: number,
  // changeLang,
  environment: {
    language: string
    user: any,
    impersonation: boolean
  }
}

function LanguageSwitchContainer(props: LanguageSwitchProps) {

  const {
    details: {
      name,
      text
    },
    index,
    environment: {
        language,
        user,
        impersonation
    }
  } = props;

  const {
    endpoints
  } = configs;

  const actionsChangeLanguage = props.actions?.changeLang || undefined;

  const onChangeLanguage = (locale: LANGUAGE_TYPE) => {
    sessionStorage.language = locale === languageTypes.ENGLISH ? languageTypes.ENGLISH_STR : languageTypes.SPANISH_STR;
    actionsChangeLanguage && actionsChangeLanguage(endpoints.CHANGE_LANGUAGE.processReplacements({ language: locale }));
};

  const onCheckKeyPress = e => e.nativeEvent.keyCode === 13 && onChangeLanguage('en');

  const languageSwitchProps: LanguageProps = {
    name,
    index,
    text,
    language,
    user,
    onChangeLanguage,
    onCheckKeyPress,
    impersonation
  }

  return (
    <>
      <LanguageSwitch { ...languageSwitchProps } />
    </>
  )
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    changeLang
  }, dispatch)
})

export default connect(null, mapDispatchToProps)(LanguageSwitchContainer);